import { useTranslation } from "react-i18next";

import { Alert, InputAdornment, Stack } from "@mui/material";
import { FormikProps } from "formik";

import { FormikDecimalTextField } from "../../../../../../formik/FormikDecimalTextField";
import { FormikTextField } from "../../../../../../formik/FormikTextField";
import { FormikYesNoAutocomplete } from "../../../../../../formik/FormikYesNoAutocomplete";
import { AssetIncomeFormValues, IncomeMaxLength } from "../../IncomeView.types";
import { IncomeSectionCard } from "../income-section-card/IncomeSectionCard";

const SECTION = "clients.client.debtSettlement.assetInventory.incomeTab.selfEmployment";

interface Props {
  formik: FormikProps<AssetIncomeFormValues>;
}

export function SelfEmploymentSection({ formik }: Props) {
  const { t } = useTranslation();
  const hasSelfEmployment = formik.values.hasSelfEmploymentIncome === true;

  return (
    <IncomeSectionCard title={t(`${SECTION}.title`)}>
      <Stack gap={1}>
        <FormikYesNoAutocomplete
          id="income-has-self-employment"
          formik={formik}
          fieldName="hasSelfEmploymentIncome"
          label={t(`${SECTION}.hasSelfEmploymentIncome`)}
        />
        {hasSelfEmployment && (
          <>
            <FormikTextField
              formik={formik}
              fieldName="selfEmploymentDescription"
              label={t(`${SECTION}.description`)}
              multiline
              minRows={3}
              slotProps={{ input: { inputProps: { maxLength: IncomeMaxLength.selfEmploymentDescription } } }}
            />
            <FormikDecimalTextField
              id="income-self-employment-amount"
              formik={formik}
              fieldName="selfEmploymentMonthlyIncome"
              label={t(`${SECTION}.monthlyIncome`)}
              decimalScale={2}
              minValue={0}
              slotProps={{ input: { endAdornment: <InputAdornment position="end">€</InputAdornment> } }}
            />
            <Alert severity="info">{t(`${SECTION}.notInCalculation`)}</Alert>
          </>
        )}
      </Stack>
    </IncomeSectionCard>
  );
}
